// extracted by mini-css-extract-plugin
export var sbShowMain = "blogPostSocialShare-module--sb-show-main--31sg7";
export var wrapper = "blogPostSocialShare-module--wrapper--3BytR";
export var iconWrapper = "blogPostSocialShare-module--iconWrapper--2ndL7";